import { httpRequest } from "@services/http";
import type { OrgUser } from "./cmdListOrgUsers";

export interface CreateUserInOrgPayload {
  email: string;
  first_name: string;
  last_name: string;
  role_ids: number[];
  send_invitation_email: boolean;
}

export class CommandCreateUserInOrg {
  async run(orgId: number, payload: CreateUserInOrgPayload): Promise<OrgUser> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/organizations/${orgId}/users/`;
    return await httpRequest<OrgUser, CreateUserInOrgPayload>(url, {
      method: "POST",
      body: payload,
    });
  }
}
